import store from '../store/index.js';

export const ifNotAuthenticated = (to, from, next) => {
    // Redirect to default page
    if (store.getters.isAuthenticated) {
        next({ name: 'chat' });
        return;
    }

    next();
};

export const ifAuthenticated = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    next();
};

export const ifAppointment = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    // Prevent redirect
    if (!store.getters.hasAccessToAppointment) {
        next(false);
        return;
    }

    next();
};

export const ifCampaign = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    // Prevent redirect
    if (!store.getters.hasAccessToCampaign) {
        next(false);
        return;
    }

    next();
};

export const ifCampaignOrAppointment = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    if (!store.getters.hasAccessToCampaign && !store.getters.hasAccessToAppointment) {
        next(false);
        return;
    }

    next();
};

export const ifPayment = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    // Prevent redirect
    if (!store.getters.hasAccessToPayment) {
        next(false);
        return;
    }

    next();
};

export const ifTeamSettings = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    // Prevent redirect
    if (!store.getters.hasAccessToTeamSettings) {
        next(false);
        return;
    }

    next();
};
